import { useLanguage } from "@/context/LanguageContext";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import SectionOrnament from "@/components/SectionOrnament";
import Reveal from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FaqPage() {
  const { t } = useLanguage();
  useSeo("FAQ", "FAQ", "Häufige Fragen zu Packages, Services, Anfragen und Bewertungen.", "Questions fréquentes sur les forfaits, services, demandes et avis.");
  const items = t("faq.items");

  return (
    <div data-testid="faq-page">
      <PageHero overline={t("faq.overline")} title={t("faq.title")} />
      <section className="relative bg-cream py-24 px-6 overflow-hidden">
        <SectionOrnament variant="corners" />
        <div className="relative max-w-3xl mx-auto">
          <Reveal>
            <Accordion type="single" collapsible className="w-full">
              {items.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-border" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-heading text-xl sm:text-2xl font-light hover:no-underline py-6 hover:text-gold">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink-muted leading-relaxed text-base pb-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
